import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_URL = "/api/";
export const notificationApi = createApi({
  reducerPath: "notification",
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    GetAllNotification: builder.query({
      query: (Token) => ({
        url: `notification`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }),
      providesTags: ["notification"],
      invalidatesTags: ["Notification", "Notifications"],
    }),
    SaveNotification: builder.mutation({
      query: ({ token, data }) => ({
        url: `notification`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: data,
      }),
      invalidatesTags: ["Notification"],
    }),
  }),
});

export const { useGetAllNotificationQuery, useSaveNotificationMutation } =
  notificationApi;
